import { AutogenLayoutRenditionOverrideProfiles } from "./autogen/AutogenLayoutRenditionOverrideProfiles";
import {  DropdownSelectionEvent,  DataSourceExecutionEvent,  DataSourceRemoteDataChangeEvent,  KeyEvent } from "@mcleod/components";
import { DropdownItem } from "@mcleod/components";

export class RenditionOverrideProfiles extends AutogenLayoutRenditionOverrideProfiles {

    private timer: any;

    override onLoad() {
        //console.log(this);
        clearInterval(this.timer);
        this.timer = setInterval(() => this.HideUnhideBox(), 250);
        this.SetDoNotProcessItems();
    }

    HideUnhideBox()
    {
        clearInterval(this.timer);
        this.timer = null;
        if( this.sourceRenditionOverrideProfiles.mode == "add" )
        {
            this.tbOvrhId.visible = true;
            this.tbOvrhId.text = "";
        }
        else
        {
            this.tbOvrhId.visible = false;
            this.tbOvrhId.text = "";
            //should not have to do this here
            this.textboxFiltDesc.text = this.textboxFiltDesc2.text;
        }
    }
    /** This is an event handler for the onDropdownSelection event of tbOvrhId. */
    tbOvrhIdAfterDropdownSelection(event: DropdownSelectionEvent) {
        //this.tbOvrhId.text = this.tbOvrhId.selectedItem.caption;
        this.textboxOvrdId.text = this.tbOvrhId.selectedItem.value;
        this.textboxOvrhDesc.text = this.tbOvrhId.selectedItem.displayValue;
        this.GetNewOverrideSeq(true);
    }

    async GetNewOverrideSeq( update: boolean )
    {
        let seq=0, pseq=0;
        const oid = this.textboxOvrdId.text;
        if( this.sourceRenditionOverrideProfiles.mode == "add" )
        {   //Adding a new record
            await this.sourceRenditionOverrideProfs.search( { ovrh_id: this.textboxOvrdId.text, ovrd_seq: ">0" } );
            for( let i=0; i < this.sourceRenditionOverrideProfs.rowCount; i++ )
            {
                this.sourceRenditionOverrideProfs.rowIndex = i;
                seq = this.sourceRenditionOverrideProfs.activeRow.data.ovrd_seq;
                if( oid == this.sourceRenditionOverrideProfs.activeRow.data.ovrh_id )
                {
                    if( seq > pseq )
                        pseq = seq;
                }
            }
        }
        if( pseq > 0 || this.sourceRenditionOverrideProfs.rowCount == 0 )
        {
            pseq += 1;
            this.textboxOvrdSeq.text = pseq.toString();
            //this.textboxOvrdSeq.enabled = false;
        }
        //this.tbOvrhId.text = "";
        if( update )
            this.tbOvrhId.text = this.textboxOvrhDesc.text;
    }

    SetDoNotProcessItems()
    {
        const items: DropdownItem[] = [];
        //items.push({ caption: "None", value: "" });
        //items.push({ caption: "Yes", value: "Y" });
        //items.push({ caption: "No", value: "N" });
        items.push(new DropdownItem("Y", "Yes"));
        items.push(new DropdownItem("N", "No"));
        this.textboxOvrdProcess.items = items;
    }

/** This is an event handler for the afterExecution event of sourceRenditionOverrideProfs. */
    sourceRenditionOverrideProfsAfterExecution(event: DataSourceExecutionEvent)
    { //used when in add mode
        if( this.tbOvrhId.items )
            return;
        const rows: any[] = event.dataSource.data;
        const items: DropdownItem[] = [];
        let ovrhid = null;
        let ovrhdesc = null;
        for (const row of rows) {
            //console.log("Row: ", row );
            if( ovrhid != row._data.ovrh_id && ovrhdesc != row._data.ovrh_desc )
            {
                ovrhid = row._data.ovrh_id;
                ovrhdesc = row._data.ovrh_desc;
                //items.push({ caption: row._data.ovrh_desc, value: row._data.ovrh_id });
                items.push(new DropdownItem(row._data.ovrh_id, row._data.ovrh_desc));
            }
        }
        this.tbOvrhId.items = items;
      }

/** This is an event handler for the afterExecution event of sourceRenditionDocumentProfiles. */
    sourceRenditionDocumentProfilesAfterExecution(event: DataSourceExecutionEvent) {
        if( this.textboxOvrdDocp.items )
            return;
        const rows: any[] = event.dataSource.data;
        const items: DropdownItem[] = [];
        let docpid = null;
        for (const row of rows) {
            //console.log("Row: ", row );
            if( docpid != row._data.docp_id )
            {
                docpid = row._data.docp_id;
                //items.push({ caption: row._data.docp_id, value: row._data.docp_id });
                items.push(new DropdownItem(row._data.docp_id, row._data.docp_id));
            }
        }
        this.textboxOvrdDocp.items = items;
    }
/** This is an event handler for the afterExecution event of sourceRenditionEmailProfiles. */
    sourceRenditionEmailProfilesAfterExecution(event: DataSourceExecutionEvent) {
        if( this.textboxOvrdEmailp.items )
            return;
        const rows: any[] = event.dataSource.data;
        const items: DropdownItem[] = [];
        for (const row of rows) {
            //console.log("Row: ", row );
            //items.push({ caption: row._data.emailp_id, value: row._data.emailp_id });
            items.push(new DropdownItem(row._data.emailp_id, row._data.emailp_id));
        }
        this.textboxOvrdEmailp.items = items;
    }


/** This is an event handler for the afterExecution event of sourceRenditionFaxProfiles. */
    sourceRenditionFaxProfilesAfterExecution(event: DataSourceExecutionEvent) {
        if( this.textboxOvrdFaxp.items )
            return;
        const rows: any[] = event.dataSource.data;
        const items: DropdownItem[] = [];
        for (const row of rows) {
            //console.log("Row: ", row );
            //items.push({ caption: row._data.faxp_id, value: row._data.faxp_id });
            items.push(new DropdownItem(row._data.faxp_id, row._data.faxp_id));
        }
        this.textboxOvrdFaxp.items = items;
    }

/** This is an event handler for the afterExecution event of sourceRenditionRuleProfiles. */
    sourceRenditionRuleProfilesAfterExecution(event: DataSourceExecutionEvent) {
        if( this.textboxOvrdRulep.items )
            return;
        const rows: any[] = event.dataSource.data;
        const items: DropdownItem[] = [];
        for (const row of rows) {
            //console.log("Row: ", row );
            //items.push({ caption: row._data.rulep_id, value: row._data.rulep_id });
            items.push(new DropdownItem(row._data.rulep_id, row._data.rulep_id));
        }
        this.textboxOvrdRulep.items = items;
    }

/** This is an event handler for the afterExecution event of sourceRenditionFilterProfs. */
  sourceRenditionFilterProfsAfterExecution(event: DataSourceExecutionEvent) {
    if( this.textboxFiltDesc.items )
        return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    const items2: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.filt_desc, value: row._data.filt_id });
        items.push(new DropdownItem(row._data.filt_id, row._data.filt_desc));
        //items2.push({ caption: row._data.filt_exprsn, value: row._data.filt_exprsn });
        items2.push(new DropdownItem(row._data.filt_exprsn, row._data.filt_exprsn));
    }
    this.textboxFiltDesc.items = items;
    this.textboxFiltExprsn.items = items2;
  }

/** This is an event handler for the onDropdownSelection event of textboxFiltDesc. */
    textboxFiltDescAfterDropdownSelection(event: DropdownSelectionEvent) {
        const desc: any = this.textboxFiltDesc.text;
        let fid=-1;
        for( let i = 0; i < this.textboxFiltDesc.items.length; i++ )
        {
            if( desc == this.textboxFiltDesc.items[i].displayValue )
            {
                fid = i;
                break;
            }
        }
        if( fid >= 0 )
        {
            this.textboxFiltExprsn.selectedItem = this.textboxFiltExprsn.items[fid];
            this.textboxOvrdFilterid.text = this.textboxFiltDesc.items[fid].value;
        }
    }

/** This is an event handler for the onKeyUp event of textboxOvrhDesc. */
  textboxOvrhDescOnKeyUp(event: KeyEvent) {
        this.GetNewOverrideId();
  }

    async GetNewOverrideId()
    {
        let oid = 0, poid = 0;
        if( this.sourceRenditionOverrideProfiles.mode == "add" )
        {   //Adding a new record
            await this.sourceRenditionOverrideProfs.search( { ovrh_id: ">0" } );
            for( let i=0; i < this.sourceRenditionOverrideProfs.rowCount; i++ )
            {
                this.sourceRenditionOverrideProfs.rowIndex = i;
                oid = this.sourceRenditionOverrideProfs.activeRow.data.ovrh_id;
                if( oid > poid )
                {
                    poid = oid;
                }
            }
        }
        if( poid > 0 || this.sourceRenditionOverrideProfs.rowCount == 0 )
        {
            poid += 1;
            this.textboxOvrdId.text = poid.toString();
            //this.textboxOvrdSeq.enabled = false;
            this.GetNewOverrideSeq(false);
        }
    }
}
